import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import symbolStatus from "./symbolStatus";
import useMainMenuList from "./useMainMenuList";
import useSnsList from "./useSnsList";
import usePopupList from "./usePopup";
import userInfo from "./useUserInfo";
import getCoinList from "./getCoinList";
import useGlobalList from "./useGlobalList";
import brief from "./useBrief";
import useChartCheckbox from "./useChartCheckbox";
import account from "./account";
import transact from "./transact";
import user_history from "./user_history";
import useFullScreen from "./useFullScreen";
const store = createStore({
  modules: {
    symbolStatus,
    useMainMenuList,
    useSnsList,
    usePopupList,
    userInfo,
    getCoinList,
    useGlobalList,
    brief,
    useChartCheckbox,
    account,
    transact,
    user_history,
    useFullScreen,
  },
  plugins: [
    createPersistedState({
      paths: ["getCoinList", "usePopupList.isRefPopup"],
    }),
  ],
});

export default store;
